export default __webpack_public_path__ + "static/media/bullrun-1.86b86f5f.png";